import includes from 'lodash/includes';

import type { Step } from '../types/step';
import type { AppData } from '../../types/app_data';
import { StepCategory } from '../../types/app_data';
import { getPartnerWelcomePageType, PartnerWelcomePageType } from '../../utils/partner';
import { growthBookInstance } from '../../utils/analytics/growthbook';
import { ABTestNamePhone } from '../../utils/enabled_features/ab_tests';

export const PhoneStep: Step = {
  id: 'phone',
  pathname: '/phone',
  canShow: (appData: AppData) => {
    if (appData.isOnboardingLite) return false;
    // WelcomeLanding is almost same as Phone screen, if WelcomeLanding is shown, we don't need to show Phone screen
    if (
      includes(
        [PartnerWelcomePageType.WelcomeLanding, PartnerWelcomePageType.WelcomeLandingPrefill],
        getPartnerWelcomePageType(appData)
      )
    ) {
      return false;
    }

    /* Be consistent with the phone name ABTest, if ABTest is on, we should show phone step, because name step is skipped. */
    if (growthBookInstance?.getFeatureValue(ABTestNamePhone.storageKey, 0) === 0) {
      // InterstitialWithPhone has phone input, so we don't need to show Phone screen again.
      if (getPartnerWelcomePageType(appData) === PartnerWelcomePageType.InterstitialWithPhone) {
        return false;
      }
    }

    return !appData.phoneVerified;
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => !!appData.phone && !!appData.signupUserSuccess,
  category: () => StepCategory.Account,
};
